/**
 * VenueLocationCard — where the workshop is: the venue's name and street
 * address, with a Get directions button that opens driving directions.
 * Renders nothing for a private event with no venue.
 */
import { MapPin, Navigation } from 'lucide-react';

import type { WorkshopDetail } from '../../../../api/workshops';

import { directionsUrlFor, venueAddressLines } from './venue-directions';

export function VenueLocationCard({ workshop }: { workshop: WorkshopDetail }) {
  const address = workshop.venueAddress;
  if (!address) return null;
  const [street, cityLine] = venueAddressLines(address);

  return (
    <section
      className="nb-card"
      aria-label="Venue address"
      style={{ display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}
    >
      <MapPin size={20} aria-hidden="true" style={{ color: 'var(--nb-primary)', flexShrink: 0 }} />
      <address style={{ flex: 1, minWidth: 180, fontStyle: 'normal', lineHeight: 1.45 }}>
        <div style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--nb-ink)' }}>
          {workshop.venueName}
        </div>
        <div style={{ fontSize: 13, color: 'var(--nb-muted)' }}>{street}</div>
        <div style={{ fontSize: 13, color: 'var(--nb-muted)' }}>{cityLine}</div>
      </address>
      <a
        href={directionsUrlFor(address)}
        target="_blank"
        rel="noopener noreferrer"
        className="nb-btn nb-btn-primary nb-tap"
        style={{ fontSize: 12.5, textDecoration: 'none', display: 'inline-flex', gap: 6 }}
      >
        <Navigation size={14} aria-hidden="true" />
        Get directions
      </a>
    </section>
  );
}
